import React, { Component } from 'react'

export default class LoginForm extends Component {
    render() {
        return (
<form className="login_form" action="/api/login" method="POST">
<label htmlFor="username">Username</label><input type="text" id="username" name="username"/>
<br/>
<label htmlFor="password">Password</label><input type="password" id="password" name="password"/>
<br/>
<input type="submit"/>
</form>
        )
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/util/LoginForm.js